import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthCedentialsService } from '../guards/auth-credentials.service';
import { Router } from '@angular/router';

@Injectable()
export class InterceptorService implements HttpInterceptor {
  constructor(
    private readonly authCedentialsService: AuthCedentialsService,
    private readonly router: Router
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const tokenJwt = this.authCedentialsService.getToken();
    const authReq = req.clone({
      setHeaders: {
        Authorization: `${tokenJwt}`,
      },
    });

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 200) {
          window.location.href = error.url;
        } else if (error.status === 404 ) {
          window.location.href = error.url;
        } else if (error.status === 401) {
          this.authCedentialsService.removeToken();
          this.router.navigate(['/login'], { queryParams: { error: true } });
        }
        return throwError(error);
      })
    );
  }
}
